exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.center {\n    margin: auto;\n    width: 50%;\n    padding: 10px;\n}\n.gumb {\n   border: none;\n  border-radius: 10px;\n  color: #ffffff;\n  font-size: 11px;\n  background: gray;\n  padding: 10px 20px 10px 20px;\n  text-decoration: none;\n}\n.focused {\n  background-color: green;\n}\n.wrong {\n  background-color: red;\n  border: 1px solid #f44336;\n}\n#comment {\n  resize: none;\n}\n#reportExercise:hover {\n  cursor: pointer;\n}\n.skrij {\n  list-style: none;\n}\na.first::after {\n  content:' ...'\n}\na.last::before {\n  content:'... '\n}\n.current {\n  color: red;\n}\n.exerciseBox .box-header {\n  background-color: #f5f5f5;\n  height: 100%;\n}\n\n\n/* .pagination .active a {\n    background-color: #5cb85c;\n    border-color: #dddddd;\n    cursor: default;\n} */\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-34720fbf","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/exercises/Exercises.vue
// module id = 905
// module chunks = 1